import React, { useRef, useState } from 'react';
import { JitsiMeeting } from '@jitsi/react-sdk';
import { useDispatch, useSelector } from 'react-redux';
import { SET_RUNNING_CALLS, SHOW_LIST_ONGOING, START_JITSI_CALL } from '../store';
import { callAPI } from '../helper/apiUtils';
import './JitsiCallComp.css';
import '../styles/components.css';   

const RCJitsiCall = ({ isJitsiCallStarted, user }) => {
    const { roomId, roomName, isGroupChat } = isJitsiCallStarted;
    const [showLoader, setShowLoader] = React.useState(true);
    const dispatch = useDispatch();
    const displayName = `${user.firstName} ${user.lastName}`;
    const runningCalls = useSelector(e => e.runningCalls)
    const apiRef = useRef(null);
    const [participants, setParticipants] = useState([]);
    const [callAdmin, setCallAdmin] = useState(null);
    const [isCallActive, setIsCallActive] = useState(false);
    const remoteCountRef = useRef(0);
    const hadOthersRef = useRef(false);
    const hasLeftRef = useRef(false);
    const aloneTimerRef = useRef(null);



    const EndJitsiCall = async () => {
        if (hasLeftRef.current) return;
        hasLeftRef.current = true;
        if (aloneTimerRef.current) {
            clearTimeout(aloneTimerRef.current);
            aloneTimerRef.current = null;
        }
        dispatch({ type: START_JITSI_CALL, payload: false });
        let newRunningCalls = runningCalls.filter(e => e.groupId !== roomId);
        if (newRunningCalls.length === 0) {
            dispatch({ type: SHOW_LIST_ONGOING, payload: false })
        }
        dispatch({ type: SET_RUNNING_CALLS, payload: newRunningCalls })
        await callAPI(`/videochat/leave`, {}, "POST", { room: roomId });       
    }


    const LeaveTheCall = async () => {
        dispatch({ type: START_JITSI_CALL, payload: false });
        let newRunningCalls = runningCalls.filter(e => e.groupId !== roomId);
        if (newRunningCalls.length === 0) {
            dispatch({ type: SHOW_LIST_ONGOING, payload: false })
        }
        dispatch({ type: SET_RUNNING_CALLS, payload: newRunningCalls })
    }




    const handleApiReady = (api) => {
        setShowLoader(false);
        apiRef.current = api;
        // Event listener for participant join
        api.addListener("participantJoined", (participant) => {
            console.log("participantJoined", participant);
            remoteCountRef.current += 1;
            hadOthersRef.current = true;
            if (aloneTimerRef.current) {
                clearTimeout(aloneTimerRef.current);
                aloneTimerRef.current = null;
            }
            setParticipants((prev) => [
                ...prev,
                { id: participant.id, name: participant.displayName },
            ]);
        });
        // Event listener for participant leave
        api.addListener("participantLeft", (participant) => {
            console.log("participantLeft", participant);
            remoteCountRef.current = Math.max(0, remoteCountRef.current - 1);
            setParticipants((prev) =>
                prev.filter((p) => p.id !== participant.id)
            );
            // NOTE: Do NOT auto-end the call when we become the only participant.
            // A participant leaving must never end the call for everyone else.
            // The call ends only when THIS user leaves (videoConferenceLeft) or
            // when a moderator uses "End meeting for all" (which destroys the room
            // for everyone). The backend destroys the call once its last active
            // participant leaves, and the videoCallEnded socket broadcast syncs
            // that end-for-all across all clients.
        });
        // Event listener for call ended
        api.addListener("videoConferenceLeft", () => {
            console.log("videoConferenceLeft");
            EndJitsiCall()
        });
    };


    return (
        <div className="jitsi-call-comp">
            {showLoader && (
                <div className="jitsi-call-comp__loader">
                    <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            )}
            <JitsiMeeting
                domain="jitsi.kjuup.de"
                roomName={roomId || ""}
                configOverwrite={{
                    startWithAudioMuted: true,
                    startScreenSharing: false,
                    enableEmailInStats: false,
                    'prejoinConfig.enabled': false,
                    // Set the title locally on every client (don't rely on Jitsi
                    // propagating the moderator's subject to late joiners, which
                    // stopped working after the Jitsi server update).
                    subject: roomName || ' ',
                    // Disable P2P so 2-participant (DM) calls behave exactly like
                    // group calls — all media flows through the JVB bridge instead
                    // of a direct peer connection. This keeps DM calls stable and
                    // consistent with multi-party calls (no separate 1:1 path).
                    p2p: { enabled: false },
                }}
                interfaceConfigOverwrite={{
                    APP_NAME: 'Kjuup',
                    SHOW_JITSI_WATERMARK: false,
                    TOOLBAR_BUTTONS: [
                        "microphone",
                        "camera",
                        "closedcaptions",
                        "desktop",
                        "embedmeeting",
                        "fullscreen",
                        "hangup",
                        "chat",
                        "recording",
                        "livestreaming",
                        "etherpad",
                        "sharedvideo",
                        "settings",
                        "raisehand",
                        "videoquality",
                        "filmstrip",
                        "invite",
                        "stats",
                        "shortcuts",
                        "tileview",
                        "download",
                        "help",
                        "mute-everyone",
                        "security",
                    ]
                }}
                userInfo={{
                    displayName: displayName,
                    email: user.email,
                }}
                onApiReady={handleApiReady}
                getIFrameRef={(iframeRef) => {
                    iframeRef.style.height = 'var(--app-height)'; // Ensure iframe is always visible
                }}
            />
        </div>
    );
};

export default RCJitsiCall;
